<template>
  <div>
      <div class="testresults">
        <div class="f14 mb10 ml10 title">
            <span>真题报告结果</span>
          </div>
        <el-card class="box-card" :body-style="{ padding: '5px' }">
          <!-- <div slot="header" class="clearfix">
            <span>{{testResultsR.paperName}}</span>
          </div> -->
          <div class="text item">
            <span>您的得分</span>
            <span>{{testResultsR.score}}分</span>
          </div>
          <div class="text item">
            <span>最高分</span>
            <span>{{testResultsR.wholeScoreInfo.highestScore}}分</span>
          </div>
          <div class="text item">
            <span>平均分</span>
            <span>{{testResultsR.wholeScoreInfo.averageScore}}分</span>
          </div>

          <div class="text item">
            <span>该真题已做人数</span>
            <span>{{testResultsR.wholeScoreInfo.totalAnsNum}}人</span>
          </div>
        </el-card>


        <!-- <el-card class="m10" v-for="(item,index) in testResultsR.subTypeResultList" :key="index"
        :body-style="{ padding: '5px' }">
          <div class="f14 mb10">
            <span>{{item.subTypeName}}</span>
          </div>
          <div class="f12 ">
            <span>对题数</span><span  class="yecolor">{{item.rightNum}}/{{item.totalNum}}</span>
            <span>用时</span><span class="yecolor">{{item.readableTotalTime}}</span>
          </div>
        </el-card> -->
        <el-card  class="box-card">
          <div class="f14 mb10 title">
            <span>专项掌握情况</span>
          </div>
          <el-collapse accordion>
            <el-collapse-item  v-for="(item,index) in testResultsR.subTypeResultList" :key="index">
              <template slot="title">
                    <span>{{item.subTypeName}}</span>
                    <span>对题数</span><span  class="yecolor">{{item.rightNum}}/{{item.totalNum}}</span>
                    <span>用时</span><span class="yecolor">{{item.readableTotalTime}}</span>
              </template>
              <div>
                 <div class="flex">
                    <div  v-for="(list,index1) in item.subjectList" @click="VuegotoAnalysis(list.subjectId)">
                       <div  v-if="list.correctItem==list.choseItem"  class="yessubject">
                         {{index1+1}}
                       </div>
                       <div  v-else="list.correctItem!=list.choseItem"  class="nosubject">
                         {{index1+1}}
                       </div>
                    </div>
                 </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-card>
      </div>
      <div v-if="!testResultsR"
        v-loading="loading"
        class="h100">
      </div>



  </div>
</template>

<script>
import { api_dry_result } from "../../networks/DryRun"
export default {
  name: 'HelloWorld',
  data () {
    return {
      testResultsR:[],
      loading: true,
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    router_paperId() {//卷子id
      return this.$route.params.paperId
    },
    router_paperName() {//卷子name
      return this.$route.params.paperName
    },
  },
  created: function () {
      var context = this;
      var userid = context.user.user_id;
      var paperId = context.router_paperId;
      var paperName = context.paperName;
      //1.请求网络层
      var promise = api_dry_result(context,userid,paperId);
      //2.更新返回数据
      promise.then(function(data) {
          context.testResultsR=data.data.result;
          context.testResultsR.paperName=paperName;

      }).catch(function(error){
      });
  },
  methods: {
   VuegotoAnalysis(subjectId){
     var context = this;
      context.$router.push({ name: 'SubjectId', params: { subjectId: subjectId}});
   }
  }
}
</script>


<style scoped>
.testresults{
 width:60%;
 margin:0 auto;
}
.box-card{
  margin-bottom:10px;
  margin-left:10px;
  margin-right:10px;
  color:#606266;
}
.m10{
   margin:10px;
}
.mb10{
   margin-bottom:10px;
}
.ml10{
   margin-left:10px;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 8px;
  display: flex;
  justify-content:  space-between;
      margin-left: 13px;
    margin-right: 20px;
}
.yecolor{
  color:#FFBC40;
}
.f14{
  font-size:14px;
}
.f12{
  font-size:12px;
}
.clearfix{
     text-align: center;
}

.flex{
  display:flex;
  flex-wrap: wrap;
}

 .btnsm {
    height: 40px;
    width:100px;
    font-size: 12px;
    line-height: 4px;
    background-color: #ffbc40;
    color: #fff;
    margin:20px auto;
}
.h100{
  min-height:676px;
  height:100%;
}
.nosubject{
  height:40px;
  width:40px;
  background-color:#f56c6c;
  border-radius: 50%;
  text-align:center;
  display: flex;
   align-items: center;
   justify-content: center;
   margin-top:10px;
   margin-right:10px;
   color:#fff;

}
.yessubject{
  height:40px;
  width:40px;
  border-radius: 50%;
  text-align:center;
  display: flex;
   align-items: center;
   justify-content: center;
   margin-top:10px;
   margin-right:10px;
   color:#fff;
  background-color:#67c23a;
}
</style>



// WEBPACK FOOTER //
// src/components/DryRun/testResults.vue